import { createRoute } from '@tanstack/react-router';

import { DesignGuidePage } from '$/pages/DashboardPages/pages/DesignGuide';
import { useDesignGuideStore } from '$/pages/DashboardPages/pages/DesignGuide/stores/useDesignGuideStore';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { STANDARD_STALE_TIME } from '$/services/constants';

export const DesignGuideRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/designguide',
  component: DesignGuidePage,
  staleTime: STANDARD_STALE_TIME,
  onLeave: () => {
    useDesignGuideStore.getState().reset();
  },
});
